import { render, staticRenderFns } from "./RiskDebtDerivativesInput.vue?vue&type=template&id=99181716&scoped=true"
import script from "./RiskDebtDerivativesInput.vue?vue&type=script&lang=js"
export * from "./RiskDebtDerivativesInput.vue?vue&type=script&lang=js"
import style0 from "./RiskDebtDerivativesInput.vue?vue&type=style&index=0&id=99181716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99181716",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VIcon,VProgressCircular,VSimpleTable,VTextField})
